/*eslint-disable*/
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
//import { PDFDownloadLink } from "@react-pdf/renderer";
import footerPanelStyle from "assets/jss/style-component/components/footerPanelStyle.js";
import PropTypes from "prop-types";
import React from "react";
 
const useFooterStyles = makeStyles(footerPanelStyle);

export default function FooterButtonDownload(props) { 
  const classesFooter = useFooterStyles();

  const {
    children,
    onClick,
    disabled,
    label,
    icono,
    buscar,
    back,
    next,
    save,
    borrar,
    fin,
    nuevo,
    descargar,
    ...rest
  } = props;

  return (
    <div>
      Hola
    </div>
  );
}
FooterButtonDownload.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  label: PropTypes.string,
  icono: PropTypes.node,
  back: PropTypes.bool,
  next: PropTypes.bool,
  save: PropTypes.bool,
  borrar: PropTypes.bool,
  fin: PropTypes.bool,
  nuevo: PropTypes.bool
};
